// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30xt3","top":"styles_top__1n0Ct"};